<template>
        <nav v-show="this.$route.name !== 'home' && this.$route.name !== 'welcome'"  class="navbar navbar-expand-lg p-0 m-0 mb-xs-5 bg-black">
            <div class="container-xxl d-block d-lg-none bocata">
                <div class="row align-items-center">
                    <div class="col-xs-6 col-6 logoRoca">
                        <localized-link to="/">
                            <img :src="`${publicPath}img/logoRocaGroup_${locale}.png`" width="160" class="img-responsive my-4">
                        </localized-link>
                    </div>
                    <div class="col-xs-6 col-6 text-end pe-4">
                        <localized-link to="/menu-mobile">
                            <svg class="svg-icon iconMenu">
                                <use :href="`${publicPath}icons.svg#menu`"/>
                            </svg>
                        </localized-link>
                    </div>
                </div>
            </div>
            <div class="container-xxl d-none d-lg-block">

                <div class="row table mt-3">
                <div class="col-2 text-start p-0">
                    <localized-link to="/welcome">
                        <img :src="`${publicPath}img/logoRocaGroup_${locale}.png`" width="170">
                    </localized-link>
                </div>
                <div class="col-10 border-0">
                    <div class="collapse navbar-collapse justify-content-end" id="collapseExample" data-interval="false">
                    <ul class="navbar-nav align-items-start g-0">
                        <li class="col-auto nav-item text-center d-xs-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none mt-3 align-top ">
                            <localized-link class="nav-link" to="/"  data-target="/">Home</localized-link>
                        </li>
                        <li class="col-auto nav-item text-center dropdown ">
                            <localized-link class="nav-link align-top me-3 border-end" to="/roca-group-2022/presentacion"  data-target="/roca-group-2022/presentacion" v-html="$t('nav.roca_group_2022')"></localized-link>
                            <ul class="dropdown-menu">
                                <li><localized-link class="dropdown-item ps-4" to="/roca-group-2022/presentacion">{{ $t("nav.presentacion") }}</localized-link></li>
                                <li><localized-link class="dropdown-item ps-4" to="/roca-group-2022/2022-en-resumen">{{ $t("nav.resumen") }}</localized-link></li>
                                <li><localized-link class="dropdown-item ps-4" to="/roca-group-2022/roca-group-en-el-mundo">{{ $t("nav.en-el-mundo") }}</localized-link></li>
                            </ul>
                        </li>
                        <li class="col-auto nav-item text-center dropdown">
                            <localized-link class="nav-link align-top me-3 border-end" to="/avanzando-hacia-el-futuro"  data-target="/avanzando-hacia-el-futuro" v-html="$t('nav.avanzando')"></localized-link>
                            <ul class="dropdown-menu">
                                <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/crecimiento">{{ $t("nav.crecimiento") }}</localized-link></li>
                                <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/excelencia-operacional">{{ $t("nav.excelencia-operacional") }}</localized-link></li>
                                <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/innovacion">{{ $t("nav.innovacion") }}</localized-link></li>
                                <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/transformacion-digital">{{ $t("nav.transformacion-digital") }}</localized-link></li>
                                <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/sostenibilidad">{{ $t("nav.sostenibilidad") }}</localized-link></li>
                                <li><localized-link class="dropdown-item ps-4" to="/avanzando-hacia-el-futuro/personas">{{ $t("nav.personas") }}</localized-link></li>
                            </ul>
                        </li>
                        <li class="col-auto nav-item text-center dropdown">
                            <localized-link class="nav-link align-top me-3 border-end" to="/fundacion-we-are-water"  data-target="/we-are-water" v-html="$t('nav.we-are-water')"></localized-link>
                        </li>
                        <li class="col-auto nav-item text-center">
                            <localized-link class="nav-link align-top me-3 border-end" to="/informe-financiero" v-html="$t('nav.informe-financero')"></localized-link>
                        </li>
                      <li class="col-auto nav-item text-center menuLang">
                        <div class="router-language-switcher row p-0 m-0 justify-content-end">
                          <div class="col-12 text-center p-0 m-0">
                            <a class="nav-link text-center p-0 m-0" href="https://rocagroup.com/memoria_roca_2022/es">
                              <div>CAS</div>
                            </a>
                          </div>
                          <div class="col-12 text-center p-0 m-0">
                            <a class="router-active-language nav-link text-center p-0 m-0" href="https://rocagroup.com/memoria_roca_2022/en">
                              <div>ENG</div></a>
                          </div>
                        </div>
                      </li>

                        <li class="col-auto nav-item menuDownload border-start bstart ms-3">
                            <download-file  v-if="locale === 'es'"
                                            title="Descargar<br>memoria"
                                            :showtitle="true"
                                            :file="download_file"
                                            class="nav-link text-end menuDownload justify-content-end" />
                            <download-file v-if="locale==='en'"
                                           title="Download<br>report"
                                           :showtitle="true"
                                           :file="download_file"
                                           class="nav-link text-end menuDownload justify-content-end" />
                        </li>
                    </ul>
                    </div>
                </div>
            </div> <!-- navbar-collapse.// -->
            </div>
        </nav>
</template>

<script>
    import DownloadFile from "@/components/DownloadFile";
    export default {
        name: "NavigationView",
        components: {
            DownloadFile
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                isEs:true,
                isEn: false,
                locale:this.$i18n.locale,
                backgroundUrl:'@/img/pdfDownload.png',
                download_file:'Memoria_Anual_ROCA_GROUP_2022.pdf'
            }
        },
        created() {
            // Remove show class from collapsible element to close movile menu
            this.$router.afterEach(() => {
                var element = document.getElementById("collapseExample");
                element.classList.remove("show");
                this.isEs = this.$i18n.locale=="es" ? true : false;
                this.isEn = this.$i18n.locale=="en" ? true : false;
                this.locale = this.$i18n.locale;
                if(this.isEn){
                    this.backgroundUrl = '@/img/pdfDownload.png';
                    this.download_file = 'Annual_Report_ROCA_GROUP_2022.pdf';
                }
            });
        },
    };
</script>
